import { contextFactory } from '@frontend/design-system';

export type CalendarHeaderContextType = {
  calendarTodayDate: string;
  calendarEventsCount: number;
  unconfirmedCalendarEventsCount: number;
};

export const [CalendarHeaderContext, useCalendarHeaderContext] = contextFactory<CalendarHeaderContextType>(
  'useCalendarHeaderContext must be used within CalendarHeaderContext'
);
